import type { ExplainAccessInput } from './types';

export function formatExplainAccess(input: ExplainAccessInput): string {
  const lines = [
    `emailKey: ${input.emailKey}`,
    `lifecycle: ${input.lifecycle}`,
    `authExists: ${input.authExists}`,
    `authDisabled: ${input.authDisabled}`,
    `emailVerified: ${input.emailVerified}`,
    `invitedNotSignedIn: ${input.invitedNotSignedIn}`,
    `grants: ${input.grants.map((grant) => `${grant.role}:${grant.source}`).join(', ') || '(none)'}`,
    `subscriptions: ${input.activeSubscriptions.join(', ') || '(none)'}`,
    `lastSessionError: ${input.lastSessionError ?? '(none)'}`,
    `lastSignInLinkSend: ${input.lastSignInLinkSend ?? '(none)'}`,
    `knownUids: ${input.knownUids}`,
    `fallbackLegacy: ${input.fallbackLegacy}`,
  ];
  if (input.authDisabled && input.lifecycle === 'existing') {
    lines.push('NOTE: Auth disabled without deleted grant — diagnostic only, not auto-delete.');
  }
  return lines.join('\n');
}

export function explainAccessFromRow(row: ExplainAccessInput): string {
  return formatExplainAccess(row);
}
